import React from "react";
import ReactPlayer from "react-player/youtube";
import IngredientsSet from "./Ingredients/ingredients-set";
import MethodSet from "./Methods/method-set";

function RecipeMain(props) {
  return (
    <div className="recipe-main black-text">
      <div className="recipe-video-wrapper">
        <ReactPlayer url={props.youtubeLink} width="100%" />
      </div>
      <h4 className="recipe-subheading">INGREDIENTS</h4>
      {props.sets.map((set, index) => {
        return (
          <IngredientsSet
            key={index}
            title={set.ingredientSetTitle}
            ingredientsList={set.ingredients}
          />
        );
      })}
      <br />
      <h4 className="recipe-subheading">METHOD</h4>
      {props.methods.map((method, index) => {
        return <MethodSet key={index} methodInfo={method} />;
      })}
    </div>
  );
}

export default RecipeMain;
